import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { generateClient } from 'aws-amplify/data';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Schema } from '../../../../amplify/data/resource';
import AgentsFilesIcon from '../../../components/activeIcons/AgentsFilesIcon';
import AgentsFundsIcon from '../../../components/activeIcons/AgentsFundsIcon';
import AgentsListIcon from '../../../components/activeIcons/AgentsListIcon';
import Add from './List/Add';

const apiClient = generateClient<Schema>();

const Agents = () => {
  const theme = useTheme();

  const location = useLocation();

  const [open, setOpen] = useState(false);

  const handleDownload = async () => {
    try {
      const response = await apiClient.queries.downloadAdminPayments({});
      console.log('Полный ответ:', response);

      if (response && response.data) {
        let responseData;
        if (typeof response.data === 'string') {
          try {
            responseData = JSON.parse(response.data);
          } catch (e) {
            console.error('Ошибка при парсинге JSON:', e);
            responseData = response.data;
          }
        } else {
          responseData = response.data;
        }

        console.log('Ответ от сервера (после парсинга):', responseData);

        let base64Data = null;

        if (responseData.body) {
          base64Data = responseData.body;
        } else if (typeof responseData === 'string') {
          base64Data = responseData;
        } else if (responseData.statusCode && responseData.body) {
          base64Data = responseData.body;
        }

        if (base64Data) {
          console.log('Найдены данные для скачивания');

          const binaryData = atob(base64Data);

          const bytes = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            bytes[i] = binaryData.charCodeAt(i);
          }

          const blob = new Blob([bytes], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = 'payments.xlsx';

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);
        } else {
          console.error('Error:', responseData);
        }
      } else {
        console.error('Неверный формат ответа:', response);
      }
    } catch (error) {
      console.error('Ошибка при скачивании файла:', error);
    }
  };

  return (
    <>
      <Stack spacing={2.5}>
        <Stack direction="row" justifyContent="space-between">
          {location.pathname === '/agents/payments' ? (
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: 'pointer' }}
              onClick={handleDownload}
            >
              <img alt="download" src={'/assets/admin/download.svg'} />
            </Stack>
          ) : (
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setOpen(true)}
            >
              <img
                alt="logo"
                src={'/assets/client/add.svg'}
                style={{ width: '35px', height: '35px' }}
              />
              <Typography
                fontSize="30px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
              >
                הוסף סוכן
              </Typography>
            </Stack>
          )}
          <Typography
            fontSize="30px"
            fontWeight="700"
            fontFamily={'AlmoniDL'}
            textAlign="right"
          >
            סוכנים
          </Typography>
        </Stack>
        <Divider
          sx={{
            width: '100%',
            height: '1px',
            backgroundColor: theme.palette.dark.border,
          }}
        />
        <Stack direction="row-reverse" spacing={2}>
          <FilesButton active={location.pathname === '/agents/payments'} />
          <FundsButton active={location.pathname === '/agents/funds'} />
          <ListButton active={location.pathname === '/agents/list'} />
        </Stack>
        <Outlet />
      </Stack>
      <Add
        open={open}
        onClose={() => {
          setOpen(!open);
        }}
      />
    </>
  );
};

export default Agents;

const FilesButton = ({ active }: { active: boolean }) => {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        background: '#FDFDFD80',
        borderRadius: '24px',
        p: '17px',
        width: '322px',
        cursor: 'pointer',
      }}
      direction="row-reverse"
      spacing={2}
      alignItems="center"
      onClick={() => navigate('/agents/payments')}
    >
      <Box
        sx={{
          background: active ? '#343434' : '#FFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '16px',
          p: '16px',
        }}
      >
        <AgentsFilesIcon active={active} />
      </Box>
      <Typography fontSize="20px" fontWeight="700" fontFamily={'AlmoniDL'}>
        הוראות תשלום
      </Typography>
    </Stack>
  );
};

const FundsButton = ({ active }: { active: boolean }) => {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        background: '#FDFDFD80',
        borderRadius: '24px',
        p: '17px',
        width: '322px',
        cursor: 'pointer',
      }}
      direction="row-reverse"
      spacing={2}
      alignItems="center"
      onClick={() => navigate('/agents/funds')}
    >
      <Box
        sx={{
          background: active ? '#343434' : '#FFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '16px',
          p: '16px',
        }}
      >
        <AgentsFundsIcon active={active} />
      </Box>
      <Typography fontSize="20px" fontWeight="700" fontFamily={'AlmoniDL'}>
        חברות ביטוח ומוצרים
      </Typography>
    </Stack>
  );
};

const ListButton = ({ active }: { active: boolean }) => {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        background: '#FDFDFD80',
        borderRadius: '24px',
        p: '17px',
        width: '322px',
        cursor: 'pointer',
      }}
      direction="row-reverse"
      spacing={2}
      alignItems="center"
      onClick={() => navigate('/agents/list')}
    >
      <Box
        sx={{
          background: active ? '#343434' : '#FFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '16px',
          p: '16px',
        }}
      >
        <AgentsListIcon active={active} />
      </Box>
      <Typography fontSize="20px" fontWeight="700" fontFamily={'AlmoniDL'}>
        סוכני ביטוח
      </Typography>
    </Stack>
  );
};
